<template>
  <span>
    <v-card
      class="align-center pt-0"
      width="350"
      height="100%"
      color="messageBubble"
      elevation="0"
    >
      <v-card-title class="pa-0 ma-0 my-1">
        <v-btn x-small outlined color="cleed_blue">
          <b>Brands</b>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-1">
        <v-chip
          class="pa-2 ma-1 white--text"
          small
          label
          v-for="(chip, index) in message.brands"
          :key="index"
          color="grey darken-3"
        >
          <b>{{ translate(chip) || chip }}</b>
        </v-chip>
      </v-card-text>
    </v-card>
  </span>
</template>

<script>
export default {
  name: "Chat_brands",
  props: {
    message: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({}),
  computed: {
    store_config() {
      const data = this.$store.state.store_config.store;
      return data;
    },
  },
  created() {},
  methods: {
    translate(data) {
      const steps = data.name || data;
      let keys = "";
      if (steps && steps.split(".")) keys = steps.split(".");
      let result = this.store_config.i18n[this.$i18n.locale];
      for (let i = 0; i < keys.length; i++) {
        const element = keys[i];
        if (result[element]) result = result[element];
        else return null;
      }
      return result;
    },
  },
};
</script>
<style scoped></style>
